import { EntryTable } from "@/components/entries/EntryTable";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAdminViewModel } from "@/pages/dashboard/admin/AdminViewModelContext";

export function AdminReportView() {
  const {
    user,
    queryClient,
    isAdmin,
    isManagerOnly,
    isReadonlyAdmin,
    isDualManagerReadonly,
    canViewReports,
    canEditPunches,
    managedEditUserIds,
    filterCostCode,
    setFilterCostCode,
    filterCustomer,
    setFilterCustomer,
    filterEmployee,
    setFilterEmployee,
    filterCostCodeSearch,
    setFilterCostCodeSearch,
    filterCostCodeOpen,
    setFilterCostCodeOpen,
    filterCostCodeRef,
    filterCustomerSearch,
    setFilterCustomerSearch,
    filterCustomerOpen,
    setFilterCustomerOpen,
    filterCustomerRef,
    filterEmployeeSearch,
    setFilterEmployeeSearch,
    filterEmployeeOpen,
    setFilterEmployeeOpen,
    filterEmployeeRef,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    entriesSearch,
    setEntriesSearch,
    entriesPage,
    setEntriesPage,
    entriesPageSize,
    setEntriesPageSize,
    exportError,
    setExportError,
    filterCostCodesData,
    filterCustomersData,
    filterEmployeesData,
    entriesLoading,
    entriesCountData,
    correctionStats,
    correctionStatsLoading,
    filteredEntries,
    chartData,
    handleExport,
  } = useAdminViewModel();

  return (
                <Card>
                  <CardHeader>
                    <CardTitle>
                      {isDualManagerReadonly
                        ? "Manager Report (account view)"
                        : isManagerOnly
                          ? "Manager Report"
                          : isReadonlyAdmin
                            ? "Read-Only Admin Report"
                            : "Admin Report"}
                    </CardTitle>
                    <CardDescription>
                      {entriesLoading
                        ? "Loading..."
                        : `${entriesCountData?.count ?? 0} total record(s)`}
                      {isDualManagerReadonly
                        ? " — viewing all employees; edit limited to your teams"
                        : isManagerOnly
                          ? " — team members you manage"
                          : ""}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <EntryTable
                      entries={filteredEntries}
                      currentUserId={user?.id}
                      canEditPunches={canEditPunches}
                      editableUserIds={managedEditUserIds}
                      canDeletePunches={!!isAdmin}
                      onEntryUpdated={() => {
                        void queryClient.invalidateQueries({ queryKey: ["entries"] });
                        void queryClient.invalidateQueries({ queryKey: ["recent-entries"] });
                        void queryClient.invalidateQueries({ queryKey: ["correction-stats"] });
                      }}
                      onEntryDeleted={() => {
                        void queryClient.invalidateQueries({ queryKey: ["entries"] });
                        void queryClient.invalidateQueries({ queryKey: ["recent-entries"] });
                        void queryClient.invalidateQueries({ queryKey: ["entries-count"] });
                        void queryClient.invalidateQueries({ queryKey: ["recent-entries-count"] });
                      }}
                    />
                    <div className="mt-4 flex flex-wrap items-center justify-between gap-2">
                      <div className="flex items-center gap-2">
                        <Button variant="outline" size="sm" onClick={() => setEntriesPage((p) => Math.max(0, p - 1))} disabled={entriesPage === 0}>
                          Previous
                        </Button>
                        <span className="text-sm text-muted-foreground">
                          Page {entriesPage + 1} of {Math.max(1, Math.ceil((entriesCountData?.count ?? 0) / entriesPageSize))}
                        </span>
                        <Button variant="outline" size="sm" onClick={() => setEntriesPage((p) => p + 1)} disabled={filteredEntries.length < entriesPageSize}>
                          Next
                        </Button>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-sm text-muted-foreground">Show</span>
                        <Select value={String(entriesPageSize)} onValueChange={(v) => { setEntriesPageSize(Number(v)); setEntriesPage(0); }}>
                          <SelectTrigger className="h-8 w-20">
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent>
                            {[10, 25, 50, 100].map((s) => <SelectItem key={s} value={String(s)}>{s}</SelectItem>)}
                          </SelectContent>
                        </Select>
                        <span className="text-sm text-muted-foreground">per page</span>
                      </div>
                    </div>
                  </CardContent>
                </Card>
  );
}
